import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../../hooks/useAuth.tsx";
import {ArrowRightStartOnRectangleIcon} from "@heroicons/react/24/outline";
import {UserRolesTypes} from "../../types/userRoles.ts";
import {useEffect, useState} from "react";

const accountMenuItems: { link: string, title: string, permissionRoles?: UserRolesTypes[] }[] = [
    {title: "Konto", link: "/konto"},
    {title: "Zmiana hasła", link: "/konto/zmiana-hasla"},
    {title: "Odtwarzacz", link: "/konto/odtwarzacz"},
    {title: "Nagrania", link: "/konto/nagrania"},
    {title: "Zarządzanie banerami", link: "/konto/banery", permissionRoles: ["Administrator", "Marketing"]},
    {title: "Zarządzanie uprawnieniami", link: "/konto/uprawnienia", permissionRoles: ["Administrator"]},
    {title: "Panel administracyjny", link: "/konto/panel-administracyjny", permissionRoles: ["Administrator"]},
];

const AccountPageNav = () => {
    const _authService = useAuth();
    const _location = useLocation();
    const _navigate = useNavigate();
    const [hasUserAccess, setHasUserAccess] = useState(true);
    const [isInitialRun, setIsInitialRun] = useState(true);

    useEffect(() => {
        const currentPath = _location.pathname.toLowerCase();
        const matchedMenuItems = accountMenuItems.filter(menuItem =>
            currentPath.includes(menuItem.link.toLowerCase())
        );
        matchedMenuItems.sort((a, b) => b.link.length - a.link.length);
        if (matchedMenuItems.length > 0) {
            const matchedMenuItem = matchedMenuItems[0];

            const navMenuItemPermission = matchedMenuItem.permissionRoles;

            const hasAccess = !navMenuItemPermission || navMenuItemPermission.some(rolePermission => _authService.user?.roles.some(x => x.toLowerCase() === rolePermission.toLowerCase()));

            setHasUserAccess(hasAccess);
            if (_authService.user != undefined && !hasAccess && !isInitialRun)
                _navigate("/konto/banery");
            setIsInitialRun(false);
        }
    }, [_location, _authService.user, hasUserAccess, isInitialRun])

    return (
        <ul className={"flex shrink-0 border-b border-neutral-400 pb-4 pt-4 pl-4 z-10 min-w-full overflow-x-scroll scrollbar-hide sticky top-14 md:top-0 bg-neutral-800 overflow-y-hidden"}>
            {accountMenuItems.map((item, index) =>
                (!item.permissionRoles || _authService.user && item.permissionRoles?.some(role => _authService.user?.roles.some(x => x.toLowerCase() === role.toLowerCase()))) &&
                <li key={item.link}
                    className={`text-lg ${index < accountMenuItems.length - 1 && "border-r border-neutral-500 mb-0.5 z-10"}`}>
                    <NavLink end to={item.link} className={"pb-[19px] px-4 text-nowrap"}
                             style={({isActive}) => {
                                 return {borderColor: isActive ? "#008dd2" : "transparent", borderBottomWidth: "3px"};
                             }}>
                        {item.title.toUpperCase()}
                    </NavLink>
                </li>
            )}

            <li className={"ml-auto sticky right-0 bg-neutral-800 px-4 border-l border-sky-500 hidden md:flex z-10"}>
                <button onClick={_authService.logout}
                        className={"flex text-lg items-center text-sky-500 hover:text-[#008dd2] transition-colors"}>WYLOGUJ <ArrowRightStartOnRectangleIcon
                    className={"ml-2 w-6 h-6 stroke-2"}/></button>
            </li>
        </ul>
    );
};

export default AccountPageNav;